module.exports = __webpack_public_path__ + "static/media/kalinteploLogo.7a9d9761.png";